// Your image elements should follow this pattern:
//
// <img data-lazy-src="/path/to/photo-1x.jpg"
//      data-lazy-srcset="/path/to/photo-2x.jpg 2x"
//      alt="TODO" width="TODO" height="TODO" loading="lazy" />

export default function lazyLoadImages() {
  // Get all images:
  var lazyImages = document.querySelectorAll('[loading="lazy"]')
  // If the environment supports native lazy loading…
  if ('loading' in HTMLImageElement.prototype) {
    // Loop through each one and set its src and srcset attributes. Remember,
    // we can do this immediately because the browser will handle the lazy
    // loading behavior based on the image's loading="lazy" attribute.
    lazyImages.forEach(function(el) {
      if (el.dataset.lazySrc) {
        el.src = el.dataset.lazySrc
      }
      if (el.dataset.lazySrcset) {
        el.srcset = el.dataset.lazySrcset
      }
    })
  }
  // …otherwise, if the environment does not support native lazy loading…
  else {
    // If the environment supports intersection observers…
    if ('IntersectionObserver' in window) {
      // Setup an observer that will set each image's src and srcset attributes
      // only when they pass into view:
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(el) {
          if (el.intersectionRatio > 0) {
            if (el.target.dataset.lazySrc) {
              el.target.src = el.target.dataset.lazySrc
            }
            if (el.target.dataset.lazySrcset) {
              el.target.srcset = el.target.dataset.lazySrcset
            }
            observer.unobserve(el.target)
          }
        })
      })
      lazyImages.forEach(function(el) {
        observer.observe(el)
      })
    }
    // …otherwise, if the environment does not support intersection obvservers…
    else {
      // …screw it, just set each image's src and srcset attributes right away.
      lazyImages.forEach(function(el) {
        if (el.dataset.lazySrc) {
          el.src = el.dataset.lazySrc
        }
        if (el.dataset.lazySrcset) {
          el.srcset = el.dataset.lazySrcset
        }
      })
    }
  }
}
